'use client';

import { Dispatch, SetStateAction } from 'react';
import { MuiIconButton } from '@/components/button/MuiIconButton';
import { Star, StarOutline } from 'mdi-material-ui';
import {
  ibow2_proto_RequestUser,
  ibow2_proto_RequestUserFavorite,
} from '@/init/swagger';
import { useLogic } from './logic';

type Props = {
  requestUser: ibow2_proto_RequestUser;
  favorites: ibow2_proto_RequestUserFavorite[];
  setFavorites: Dispatch<SetStateAction<ibow2_proto_RequestUserFavorite[]>>;
  portalOfficeId: number;
};

export const FavoriteButton: React.FC<Props> = ({
  requestUser,
  favorites,
  setFavorites,
  portalOfficeId,
}) => {
  const { handleToggleFavorite, isFavorited } = useLogic({
    requestUser,
    favorites,
    setFavorites,
    portalOfficeId,
  });

  return (
    <>
      <MuiIconButton
        onClick={handleToggleFavorite}
        sx={{
          width: 32,
          height: 32,
          radius: 64,
          border: '1px solid',
          gap: 8,
          borderColor: '#E6F0F0',
          borderRadius: 64,
          p: 1,
        }}
      >
        {isFavorited() ? <Star sx={{ color: '#E3C31A' }} /> : <StarOutline />}
      </MuiIconButton>
    </>
  );
};
